import { createRouter, createWebHistory } from "vue-router";
const routes = [
    { path: "/login", component: () => import("../views/Login.vue") },
    {
        path: "/",
        component: () => import("../components/AppLayout.vue"),
        meta: { requiresAuth: true },
        children: [
            { path: "", component: () => import("../views/Dashboard.vue") },
            // ── 流程 B/G：回冲入库选择池（售后单 + 作废取消）──
            {
                path: "cancellation/pending",
                component: () => import("../views/cancellation/Pending.vue"),
                meta: { title: "回冲入库选择池" },
            },
            // v10.4.19-s /reports/cancellation 列表已并入 /cancellation/pending 底部,老 URL 重定向
            {
                path: "reports/cancellation",
                redirect: "/cancellation/pending",
            },
            {
                path: "reports/cancellation/:id",
                component: () => import("../views/cancellation/Detail.vue"),
                meta: { title: "取消单批次详情" },
            },
            // ── 流程 A：对账 ──
            {
                path: "reports/reconciliation",
                component: () => import("../views/reconciliation/List.vue"),
                meta: { title: "每日对账报告" },
            },
            {
                path: "reports/reconciliation/:id",
                component: () => import("../views/reconciliation/Detail.vue"),
                meta: { title: "对账详情" },
            },
            // ── 流程 G：作废反冲入库 ──
            {
                path: "reports/void-return",
                component: () => import("../views/voidReturn/List.vue"),
                meta: { title: "作废反冲入库" },
            },
            {
                path: "reports/void-return/:id",
                component: () => import("../views/voidReturn/Detail.vue"),
                meta: { title: "作废反冲批次详情" },
            },
            // ── 仓库库存审计（v10.4.15，v10.4.16-i 去差异改纯审计）──
            {
                path: "inventory-audit",
                component: () => import("../views/inventoryAudit/Page.vue"),
                meta: { title: "仓库库存审计" },
            },
            // ── 流程 H：智邦出司南 → 司南聚水潭无采购入库（v10.4.45）──
            {
                path: "sinan-purchase-in",
                component: () => import("../views/sinanPurchaseIn/Page.vue"),
                meta: { title: "智邦和司南出入库" },
            },
            // ── 智邦物料清单 Y1 → Z1 复制（v10.4.46）──
            {
                path: "zb-bom-copy",
                component: () => import("../views/zbBomCopy/Page.vue"),
                meta: { title: "智邦物料清单复制" },
            },
            // ── 流程 C：自动确认出库实时监控 ──
            {
                path: "confirmation/monitor",
                component: () => import("../views/confirmation/Monitor.vue"),
                meta: { title: "确认出库监控" },
            },
            {
                path: "confirmation/history",
                component: () => import("../views/confirmation/History.vue"),
                meta: { title: "确认出库批次历史" },
            },
            // ── 主数据：出口货品 ──
            {
                path: "products/export",
                component: () => import("../views/product/ExportProductList.vue"),
                meta: { title: "出口货品SKU数据" },
            },
            // ── 流程 E2：Etsy/Excel → 云途面单 ──
            {
                path: "etsy/shipment",
                component: () => import("../views/etsy/ExcelShipmentPage.vue"),
                meta: { title: "Etsy/Excel 面单打印" },
            },
            {
                path: "dropship/orders",
                component: () => import("../views/dropship/DropshipOrderPage.vue"),
                meta: { title: "代发订单系统" },
            },
            // ── 流程 E：Shopify → 云途面单（暂时下线，等业务方启用时恢复）──
            // {
            //   path: "shopify/shipment",
            //   component: () => import("../views/shopify/ShipmentHistory.vue"),
            //   meta: { title: "Shopify 面单打印记录" },
            // },
            // ── 流程 D：可发货判定 ──
            {
                path: "shipment-check",
                component: () => import("../views/shipment/Trigger.vue"),
                meta: { title: "可发货判定" },
            },
            {
                path: "shipment-check/:id",
                component: () => import("../views/shipment/Detail.vue"),
                meta: { title: "判定详情" },
            },
            // ── 系统 ──
            { path: "system", component: () => import("../views/System.vue") },
            { path: "users", component: () => import("../views/Users.vue") },
        ],
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
// 每个受控菜单对应的顶级 path 前缀（子路由归属父菜单）
const MENU_PATHS = [
    "/", "/cancellation/pending", "/confirmation/monitor", "/confirmation/history",
    "/shipment-check", "/products/export", "/etsy/shipment", "/dropship/orders",
    "/reports/reconciliation", "/reports/cancellation", "/reports/void-return",
    "/inventory-audit", "/sinan-purchase-in", "/zb-bom-copy",
    "/system", "/users",
];
function matchMenu(pathname) {
    // 精确匹配（比如 "/"）优先于前缀（不然一切都命中 "/"）
    if (pathname === "/")
        return "/";
    const hits = MENU_PATHS.filter(m => m !== "/" && (pathname === m || pathname.startsWith(m + "/")));
    if (hits.length === 0)
        return null;
    return hits.sort((a, b) => b.length - a.length)[0];
}
router.beforeEach((to, _from, next) => {
    const needAuth = to.matched.some((r) => r.meta?.requiresAuth);
    if (needAuth && !localStorage.getItem("access_token")) {
        next({ path: "/login", query: { redirect: to.fullPath } });
        return;
    }
    // 方案 B：菜单可见性守卫（防止用户直接输 URL 绕过侧栏）
    if (needAuth) {
        try {
            const raw = localStorage.getItem("user");
            const user = raw ? JSON.parse(raw) : null;
            const roles = user?.roles ?? [];
            const vm = user?.visible_menus;
            const menu = matchMenu(to.path);
            const isAdmin = roles.includes("admin");
            // 仪表盘 "/" 永远白名单：登录后的落地页，禁掉会造成死循环
            if (menu === "/") {
                next();
                return;
            }
            if (menu && !isAdmin) {
                // 是否拒绝：/users 只有 admin；或明确设了 visible_menus 且当前不在里面
                // v10.4.27 入口合并兼容：老账号只授权 /reports/void-return 时，也允许进新的回冲入库选择池。
                const allowedByLegacyVoidReturn = menu === "/cancellation/pending" &&
                    vm != null &&
                    vm.includes("/reports/void-return");
                const denied = menu === "/users" ||
                    (vm != null && !vm.includes(menu) && !allowedByLegacyVoidReturn);
                if (denied) {
                    // 挑一个能看的兜底页：优先 vm[0]，否则回仪表盘
                    const fallback = vm != null && vm.length > 0 ? vm[0] : "/";
                    // 防死循环：如果目标就是当前路径，直接放行
                    if (fallback === to.path) {
                        next();
                        return;
                    }
                    next({ path: fallback });
                    return;
                }
            }
        }
        catch { /* 解析失败就放行，落到后端 401 */ }
    }
    next();
});
export default router;
